
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { FeedbackMessage, FeedbackCategoryTag } from "@/types/feedback";
import { useState, useEffect } from "react";

export const useFeedbackList = (categoryFilter: FeedbackCategoryTag = null) => {
  const queryClient = useQueryClient();
  const [messages, setMessages] = useState<FeedbackMessage[]>([]);
  
  // Query to fetch messages
  const { data, isLoading, error } = useQuery({
    queryKey: ['feedback-messages', categoryFilter],
    queryFn: async () => {
      let query = supabase
        .from('feedback_messages')
        .select('*')
        .order('timestamp', { ascending: false });
      
      if (categoryFilter) {
        query = query.eq('category_tag', categoryFilter);
      }
      
      const { data, error } = await query;
      
      if (error) throw error;
      return data as FeedbackMessage[];
    },
  });
  
  // Set up realtime subscription
  useEffect(() => {
    const channel = supabase
      .channel('feedback-changes')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'feedback_messages' }, 
        (payload) => {
          console.log('Realtime feedback update:', payload);
          queryClient.invalidateQueries({ queryKey: ['feedback-messages'] });
        }
      )
      .subscribe((status) => {
        console.log('Feedback realtime subscription status:', status);
      });
      
    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
  
  // Effect to update messages state from data
  useEffect(() => {
    if (data) {
      setMessages(data);
    }
  }, [data]);

  return {
    messages,
    isLoading,
    error
  };
};
